import { render, staticRenderFns } from "./BlockType4.vue?vue&type=template&id=ee5ba7aa"
import script from "./BlockType4.vue?vue&type=script&lang=ts"
export * from "./BlockType4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports